module.exports = __webpack_public_path__ + "img/Board_Pk.e8ab5934.png";